import React, { useEffect, useState } from "react";
import GlobalMeta from "../../reusable/GlobalMeta";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import ImageBGSection from "../../reusable/fieldGroups/ImageBGSection";
import InternalBanner from "../../reusable/fieldGroups/InternalBanner";
import PartnersCarousel from "../../reusable/PartnersCarousel";
import RandomTestimonial from "../../reusable/RandomTestimonial";
import LatestInsights from "../../reusable/LatestInsights";
import ConsultingMenu from "./ConsultingMenu";
import PageContent from "../../layout/PageContent";
import { Box } from "@mui/system";

export default function ConsultingTraining({ page }) {
  const [pageData, setPageData] = useState();

  //Fetch page
  const { isPending, isError, data, error } = useQuery(
    ["training"], //Query key
    () =>
      axios({
        //Query function
        method: "get",
        url:
          WP_API_Settings.endpoint +
          "wp/v2/pages?slug=training&_embed=true&acf_format=standard",
      })
  );

  useEffect(() => {
    if (data?.data) {
      setPageData(data.data[0]);
    }
  }, [data]);

  return (
    <>
      <GlobalMeta />
      <InternalBanner
        featuredImage={
          pageData?._embedded?.["wp:featuredmedia"]?.[0]?.source_url
        }
        banner={pageData?.acf.internal_banner}
      />
      <ConsultingMenu />
      <PageContent content={pageData?.content.rendered} />
      <ImageBGSection
        content={pageData?.acf.image_background}
        loading={!pageData}
      />
      <Box
        sx={{
          height: "3rem",
        }}
      />
      <PartnersCarousel page={"consultancy"} loading={!pageData} />
      <RandomTestimonial
        testimonials={pageData?.acf.testimonials}
        loading={!pageData}
      />
      <LatestInsights loading={!pageData} />
    </>
  );
}
